import type { AuthUser } from '../types';

/** System-scope roles that use internal Super Admin UX (aligned with TenantProvider / API). */
export const ELEVATED_ROLE_SLUGS = new Set([
  'super_admin',
  'support_agent',
  'finance_viewer',
  'product_manager',
]);

function roleSlug(role: string): string {
  return role.split(':')[0] ?? role;
}

export function isElevatedUser(user: AuthUser | null | undefined): boolean {
  if (!user) return false;
  return user.roles.some((r) => ELEVATED_ROLE_SLUGS.has(roleSlug(r)));
}

/** Tenant-bound customer admins and members (non-elevated authenticated users). */
export function isTenantPortalUser(user: AuthUser | null | undefined): boolean {
  if (!user) return false;
  return !isElevatedUser(user);
}

export type PostLoginRoute = '/dashboard' | '/portal';

export function getPostLoginRoute(user: AuthUser | null | undefined): PostLoginRoute {
  return isElevatedUser(user) ? '/dashboard' : '/portal';
}
